export default async function GetInvestorPortfolio() {
    let url = window.RealestateService+  `/api/PaymentDetails/GetProjectWiseInvestorPaymentDetails`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}